(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal, .mt-observa');
    if (!('IntersectionObserver' in window) || reducido) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) {
      if (el.dataset.mtObs) return;
      el.dataset.mtObs = '1';
      observador.observe(el);
    });
  }

  function initComparador(raiz) {
    (raiz || document).querySelectorAll('[data-mt-comparador]').forEach(function (marco) {
      if (marco.dataset.mtInit) return;
      marco.dataset.mtInit = '1';
      var boton = marco.querySelector('.mt-ad__boton');
      var pos = parseFloat(marco.dataset.inicio || '50');
      function poner(p) {
        pos = Math.max(0, Math.min(100, p));
        marco.style.setProperty('--mt-pos', pos + '%');
        if (boton) boton.setAttribute('aria-valuenow', Math.round(pos));
      }
      function desdeEvento(ev) {
        var r = marco.getBoundingClientRect();
        var x = (ev.touches ? ev.touches[0].clientX : ev.clientX) - r.left;
        poner((x / r.width) * 100);
      }
      var arrastrando = false;
      marco.addEventListener('pointerdown', function (ev) { arrastrando = true; desdeEvento(ev); });
      window.addEventListener('pointermove', function (ev) { if (arrastrando) desdeEvento(ev); });
      window.addEventListener('pointerup', function () { arrastrando = false; });
      if (boton) {
        boton.addEventListener('keydown', function (ev) {
          if (ev.key === 'ArrowLeft') { poner(pos - 5); ev.preventDefault(); }
          if (ev.key === 'ArrowRight') { poner(pos + 5); ev.preventDefault(); }
        });
      }
      poner(pos);
      // Pequeña demostración al entrar en pantalla
      if (!reducido && 'IntersectionObserver' in window) {
        var demo = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return;
          demo.disconnect();
          var t0 = null, base = pos;
          function paso(t) {
            if (arrastrando) return;
            if (!t0) t0 = t;
            var k = (t - t0) / 1600;
            if (k >= 1) { poner(base); return; }
            poner(base + Math.sin(k * Math.PI * 2) * 18);
            requestAnimationFrame(paso);
          }
          requestAnimationFrame(paso);
        }, { threshold: 0.5 });
        demo.observe(marco);
      }
    });
  }

  function initFaq(raiz) {
    (raiz || document).querySelectorAll('.mt-faq__pregunta').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-faq__item');
        var abierto = item.classList.toggle('mt-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-mt-producto]').forEach(function (cont) {
      if (cont.dataset.mtInit) return;
      cont.dataset.mtInit = '1';
      var principal = cont.querySelector('.mt-pp__principal img');
      var minis = cont.querySelectorAll('.mt-pp__mini');
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          minis.forEach(function (x) { x.classList.remove('mt-activa'); });
          m.classList.add('mt-activa');
          if (principal) {
            principal.style.opacity = '0';
            setTimeout(function () {
              principal.src = m.dataset.grande;
              principal.removeAttribute('srcset');
              principal.style.opacity = '1';
            }, 180);
          }
        });
      });

      var datos = cont.querySelector('[data-mt-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var inputId = cont.querySelector('input[name="id"]');
      var precio = cont.querySelector('[data-mt-precio]');
      var tachado = cont.querySelector('[data-mt-tachado]');
      var boton = cont.querySelector('[data-mt-boton]');
      var formato = cont.dataset.formato || '{{amount}} €';
      function dinero(c) {
        var v = (c / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100));
      }
      function actualizar() {
        var elegidas = [];
        cont.querySelectorAll('.mt-pp__opcion').forEach(function (fs) {
          var marcado = fs.querySelector('input:checked');
          elegidas.push(marcado ? marcado.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; }
          else tachado.hidden = true;
        }
        if (boton) {
          boton.disabled = !v.available;
          var t = boton.querySelector('[data-mt-boton-texto]');
          if (t) t.textContent = v.available ? boton.dataset.textoComprar : boton.dataset.textoAgotado;
        }
        if (v.featured_image && principal) { principal.src = v.featured_image; principal.removeAttribute('srcset'); }
      }
      cont.querySelectorAll('.mt-pp__opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var cantidad = cont.querySelector('.mt-pp__cantidad input');
      cont.querySelectorAll('.mt-pp__cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(cantidad.value || '1', 10) + parseInt(b.dataset.paso, 10);
          cantidad.value = Math.max(1, n);
        });
      });
    });
  }

  function initTodo(ev) {
    var raiz = ev && ev.target && ev.target.querySelectorAll ? ev.target : document;
    initReveals(raiz);
    initComparador(raiz);
    initFaq(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
